const active = location.hostname !== 'localhost'

export class PokiWrapper {
  static isActive () {
    return active
  }

  static init (callback) {
    console.log('Poki.init')
    if (active) {
      PokiSDK.init().then(() => {
        callback()
      }).catch(() => {
        callback()
      })
      PokiSDK.setDebug(false)
    } else {
      callback()
    }
  }

  static gameplayStart () {
    console.log('Poki.gameplayStart')
    if (active) {
      PokiSDK.gameplayStart()
    }
  }

  static gameplayStop () {
    console.log('Poki.gameplayStop')
    if (active) {
      PokiSDK.gameplayStop()
    }
  }

  static gameLoadingStart () {
    console.log('Poki.gameLoadingStart')
    if (active) {
      PokiSDK.gameLoadingStart()
    }
  }

  static gameLoadingFinished () {
    console.log('Poki.gameLoadingFinished')
    if (active) {
      PokiSDK.gameLoadingFinished()
    }
  }

  static commercialBreak (callback) {
    console.log('Poki.commercialBreak')
    if (active) {
      PokiSDK.commercialBreak().then(
        () => {
          PokiWrapper.gameplayStart()
          callback()
        }
      )
    } else {
      callback()
    }
  }

  static rewardedBreak (callback) {
    console.log('Poki.rewardedBreak')
    if (active) {
      PokiSDK.rewardedBreak().then(
        (success) => {
          callback(success)
          PokiWrapper.gameplayStart()
        }
      )
    } else {
      callback(false)
    }
  }
}
